module.exports = __webpack_public_path__ + "34d5bb308f277db8649d18d97cd2b1bc.svg";